import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const ButtonSpinner = styled.span`
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  &:before {
    content: '';
    color: white;
    height: 22px;
    width: 22px;
    background: transparent;
    border-radius: 50%;
    border: 5px solid blue;
    border-color: #999 var(--primary-text-color) #999 #999;
    animation: ${rotateAnimation} 0.6s infinite ease-in-out;
  }
`;

export default ButtonSpinner;
